import { render } from "./SupplierSearch.vue?vue&type=template&id=ec669770"
import script from "./SupplierSearch.vue?vue&type=script&lang=js"
export * from "./SupplierSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__